import apiUrl from './ApiUrl'
import React, { useState, useEffect } from 'react';
import { Card, CardContent, Stack, Avatar, Typography, Grid, TextField, Autocomplete } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const filtrarCaracteres = (texto) => texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

const AddressForm = ({ getter, setter, icon, title }) => {
    const theme = useTheme()
    const envConfig = {
      url:apiUrl()
    }
    const [, setValidacion] = useState(true)
    const [coloniasDisponibles, setColoniasDisponibles] = useState([])
    const [municipio, setMunicipio] = useState('')
    const [estado, setEstado] = useState('')
    const [pais, setPais] = useState('')
  
    const catchCodigoPostal = async (codigoPostalEntrante) => {
      if (codigoPostalEntrante.length === 5) {
        try {
          setter({ ...getter, codigoPostal: codigoPostalEntrante });
          const respuesta = await fetch(`${envConfig.url}/api/v2/addresses/zip/${codigoPostalEntrante}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
              'Cache-Control': 'no-cache',
            },
          });  
          if (respuesta.ok) {
            const datos = await respuesta.json();
            setPais(filtrarCaracteres(datos.pais));
            setEstado(filtrarCaracteres(datos.estado));
            setMunicipio(filtrarCaracteres(datos.municipio));
  
            setColoniasDisponibles(datos.colonias.map(colonia => filtrarCaracteres(colonia)));
            setter(prevState => ({
              ...prevState,
              pais: datos.pais,
              estado: datos.estado,
              municipio: datos.municipio,
            }));
  
          } else {
            console.error('Respuesta no exitosa del servidor');
          }
        } catch (error) {
          console.error('Error al hacer la solicitud al servidor:', error);
        }
      }
    };
  
    useEffect(() => {
      if (getter.codigoPostal) {
        catchCodigoPostal(getter.codigoPostal);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return (
      <Card
        variant='outlined'
        sx={{ height: '100%' }}
      >
        <CardContent>
          <Stack
            spacing={1}
            useFlexGap
          >
            <Stack
              direction='row'
              spacing={1}
              alignContent='center'
            >
              <Avatar sx={{ width: 28, height: 28, backgroundColor: theme.palette.primary.main }}>{icon}</Avatar>
              <Typography variant='subtitle1'>{title}</Typography>
            </Stack>
  
            <Typography variant='subtitle2'>Datos del contacto</Typography>
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={12}
              >
                <CustomTextField
                  label="Empresa"
                  value={getter.empresa}
                  setValidation={setValidacion}
                  setter={(value) => setter({ ...getter, empresa: value })}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
              >
                <CustomTextField
                  label="Nombre"
                  value={getter.nombre}
                  required={true}
                  maxLength={15}
                  setter={(value) => setter({ ...getter, nombre: value })}
                  setValidation={setValidacion}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
              >
                <CustomTextField
                  label="Apellido paterno"
                  value={getter.apellidoPaterno}
                  required={true}
                  maxLength={15}
                  setter={(value) => setter({ ...getter, apellidoPaterno: value })}
                  setValidation={setValidacion}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
              >
                <CustomTextField
                  label="Apellido materno"
                  value={getter.apellidoMaterno}
                  maxLength={15}
                  setter={(value) => setter({ ...getter, apellidoMaterno: value })}
                  setValidation={setValidacion}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
              >
                <CustomPhoneField
                  label="Teléfono"
                  value={getter.telefono1}
                  required={true}
                  setter={(value) => setter({ ...getter, telefono1: value })}
                  setValidation={setValidacion}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
              >
                <CustomPhoneField
                  label="Teléfono alterno"
                  value={getter.telefono2}
                  setter={(value) => setter({ ...getter, telefono2: value })}
                  setValidation={setValidacion}
                />
              </Grid>
            </Grid>
  
            <Typography variant='subtitle2'>Datos del domicilio</Typography>
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={12}
                md={8}
              >
                <CustomTextField
                  label="Calle"
                  value={getter.calle}
                  required={true}
                  acceptNumbers={true}
                  maxLength={30}
                  setter={(value) => setter({ ...getter, calle: value })}
                  setValidation={setValidacion}
                />
              </Grid>
              <Grid
                item
                xs={6}
                md={2}
              >
                <CustomTextField
                    label="Número exterior"
                    value={getter.numeroExterior}
                    required={true}
                    acceptNumbers={true}
                    maxLength={10}
                    minLength={1}
                    setter={(value) => setter({ ...getter, numeroExterior: value })}
                    setValidation={setValidacion}
                />
              </Grid>
              <Grid
                item
                xs={6}
                md={2}
              >
                <CustomTextField
                    label="Número interior"
                    value={getter.numeroInterior}
                    required={false}
                    acceptNumbers={true}
                    maxLength={10}
                    setter={(value) => setter({ ...getter, numeroInterior: value })}
                    setValidation={setValidacion}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={8}
              >
                <Autocomplete
                  freeSolo
                  id="combo-box-colonia"
                  options={coloniasDisponibles}
                  value={getter.colonia || ''}
                  onInputChange={(event, newInputValue) => {
                    setter(prev => ({ ...prev, colonia: newInputValue }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Colonia"
                      placeholder="Elige una colonia"
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={4}
              >
                <CustomTextField
                  label="Código postal"
                  value={getter.codigoPostal}
                  required={true}
                  maxLength={5}
                  setter={(value) => catchCodigoPostal(value)}
                  setValidation={setValidacion}
                  readOnly={true}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
              >
                <CustomTextField
                  label="Municipio"
                  value={municipio}
                  required={true}
                  setter={(value) => setter({ ...getter, municipio: value })}
                  setValidation={setValidacion}
                  readOnly={true}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
              >
                <CustomTextField
                  label="Estado"
                  value={estado}
                  required={true}
                  setter={(value) => setter({ ...getter, estado: value })}
                  setValidation={setValidacion}
                  readOnly={true}
                />
              </Grid>
              <Grid
                item
                xs={12}
              >
                <CustomTextField
                  label="País"
                  value={pais}
                  required={true}
                  setter={(value) => setter({ ...getter, pais: value })}
                  setValidation={setValidacion}
                  readOnly={true}
                />
              </Grid>
              <Grid
                item
                xs={12}
              >
                <CustomTextField
                  label="Referencia"
                  value={getter.referencia}
                  maxLength={30}
                  acceptNumbers={true}
                  setter={(value) => setter({ ...getter, referencia: value })}
                  setValidation={setValidacion}
                  multiline={true}
                  rows={4}
                />
              </Grid>
            </Grid>
          </Stack>
        </CardContent>
      </Card>
    )
  }

const CustomTextField = ({ label, value, maxLength = 30, minLength=3, acceptNumbers = false, setter, setValidation, required = false, readOnly=false, ...otherProps }) => {
    const [isValid, setIsValid] = useState(readOnly || !required);
    // Accepted address class: letters, digits, space, '.', '-', '#', '/' and ','.
    // The decimal point must survive: "km 3.5" is a valid address and used to be
    // stored as "km 35" (the kilometre came out 10x off in the quote/label).
    // Still rejected: markup and control characters (< > " ' | \ ^ ~ ` etc.).
    const regex = acceptNumbers ? /[^a-zA-Z0-9 .#/,-]/g : /[^a-zA-Z ]/g;
    
    const handleChange = (event) => {
        const filteredValue = event.target.value.replace(regex, '');
        setter(filteredValue);
        setIsValid(
            readOnly || (
          required 
          ? filteredValue.length >= minLength && filteredValue.length <= maxLength 
          : (filteredValue.length === 0 || (filteredValue.length >= minLength && filteredValue.length <= maxLength))
            )
        );
    };
    useEffect(() => {
        console.log("isValid:", isValid);
        setValidation(readOnly || isValid);
    }, [isValid, readOnly, setValidation]);
    
    useEffect(() => {
      const filteredValue = value ? value.replace(regex, '') : '';
        setter(filteredValue);
        setIsValid(
        readOnly || (
          required 
          ? filteredValue.length >= minLength && filteredValue.length <= maxLength 
          : (filteredValue.length === 0 || (filteredValue.length >= minLength && filteredValue.length <= maxLength))
        )
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    return (
        <TextField
            variant="outlined"
            label={required ? `${label} *` : label}
            value={value}
            onChange={handleChange}
            error={!isValid}
            helperText={!isValid ? "Valor invalido" : ""}
            inputProps={{
                maxLength: maxLength,
                readOnly: readOnly,
            }}
            fullWidth
            {...otherProps}
        />
    );
};
const CustomPhoneField = ({ label, value, setter, setValidation, required = false, readOnly=false, ...otherProps }) => {
    const [isValid, setIsValid] = useState(!required);
    const regex = /[^0-9]/g;

    const handleChange = (event) => {
        const filteredValue = event.target.value.replace(regex, '');
        setter(filteredValue);
        setIsValid((required && filteredValue.length === 10) || (!required && (filteredValue.length === 10 || filteredValue.length === 0)));
    };
    useEffect(() => {
      const filteredValue = value ? value.replace(regex, '') : '';
      setter(filteredValue);
      setIsValid((required && filteredValue.length === 10) || (!required && (filteredValue.length === 10 || filteredValue.length === 0)));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => {
        setValidation(isValid);
    }, [isValid, setValidation]);

    return (
        <TextField
            variant="outlined"
            label={required ? `${label} *` : label}
            value={value}
            onChange={handleChange}
            error={!isValid}
            helperText={!isValid ? "Debe contener 10 dígitos" : ""}
            inputProps={{
                maxLength: 10,
                readOnly: readOnly,
            }}
            fullWidth
            {...otherProps}
        />
    );
};

export default AddressForm;
